import DefaultContainer from "../../../../Components/General/Dashboards/Default/DefaultContainer";

const Default = () => {
  return <DefaultContainer />;
};

export default Default;
